import React, {Component} from "react";
import {Modal, FormLayout, TextField, Banner} from '@shopify/polaris';
import axios from 'axios';

class SubmitIssue extends Component {

  state = {
    shopData: null,
    submitIssueModal: false,
    thanksIssueModal: false,
    issueSubjectValue: '',
    issueSubjectError: '',
    issueDetailValue: '',
    issueDetailError: '',
  };

  getShopData(shopUrl) {
    const url = `https://website-service-dot-autoketing-production-api-v1.appspot.com/get-data-shop`;
    const e = this;
    axios.get(url, {params: {shop_domain: shopUrl}})
      .then(function (response) {
        if (response.status === 200) {
          e.setState({shopData: response.data});
        } else {
          // console.error('response error');
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  componentDidMount() {
    function getVal(str) {
      const v = window.location.search.match(
        new RegExp('(?:[?&]' + str + '=)([^&]+)')
      );
      return v ? v[1] : undefined;
    }

    const shopUrl = getVal('shop');
    this.getShopData(shopUrl);
  }

  submitIssueAction = () => {
    const {issueSubjectValue, issueDetailValue} = this.state;
    if (issueSubjectValue === '')
      this.setState({issueSubjectError: 'Message is required'});
    if (issueDetailValue === '')
      this.setState({issueDetailError: 'Subject is required'});

    if (issueSubjectValue.length > 0 && issueDetailValue.length > 0) {
      this.submitIssueHandling({
        issueSubjectValue: this.state.issueSubjectValue,
        issueDetailValue: this.state.issueDetailValue,
        shopData: this.state.shopData
      });
      // reset form
      this.setState({issueSubjectValue: '', issueDetailValue: ''});
    }
  };

  closeThankSubmitIssue = () => {
    this.setState({thanksIssueModal: false});
  };


  // Close issue modal
  closeSubmitIssueModal = () => {
    this.props.closeSubmitModal();
  };

  submitIssueHandling = (payload) => {
    const shopName = payload.shopData.name;
    const email = payload.shopData.email;
    const url = 'https://website-service-dot-autoketing-production-api-v1.appspot.com/create-ticket';
    let bodyFormData = new FormData();
    bodyFormData.set('name', shopName);
    bodyFormData.set('email', email);
    bodyFormData.set('subject', payload.issueSubjectValue);
    bodyFormData.set('message', payload.issueDetailValue);

    const appName = this.props.appName;
    switch (appName) {
      case 'fb-chat':
        bodyFormData.set('group_id', '42000096826');
        break;
      case 'sales-pop':
        bodyFormData.set('group_id', '42000097091');
        break;
      default:
        break;
    }

    const e = this;
    axios({
      method: 'POST',
      url: url,
      data: bodyFormData,
      config: {headers: {'Content-Type': 'multipart/form-data'}}
    })
      .then(response => {
        if (response.status === 200) {
          const data = response.data;
          if (data.success) {
            // Show modal success
            e.closeSubmitIssueModal();
            e.setState({thanksIssueModal: true});
            e.props.successFeedBack();
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    let bannerTitleThankYouSubmitIssue;

    if (this.state.shopData) {
      bannerTitleThankYouSubmitIssue = `Thanks ${
        this.state.shopData.name
        }, we will get back to you soon to: ${this.state.shopData.email}`;
    }

    const openModal = this.props.openModal;

    return (
      <div>
        <Modal
          open={openModal}
          onClose={this.closeSubmitIssueModal}
          title="Submit your issue"
          primaryAction={{
            content: 'Send',
            onAction: this.submitIssueAction
          }}>
          <Modal.Section>
            <FormLayout>
              <TextField
                error={this.state.issueSubjectError}
                value={this.state.issueSubjectValue}
                onChange={subject =>
                  this.setState({
                    issueSubjectValue: subject,
                    issueSubjectError: ''
                  })
                }
                placeholder="Add the subject of your question"
              />
              <TextField
                error={this.state.issueDetailError}
                placeholder="Details"
                value={this.state.issueDetailValue}
                onChange={message =>
                  this.setState({
                    issueDetailValue: message,
                    issueDetailError: ''
                  })
                }
                multiline={5}
              />
            </FormLayout>
          </Modal.Section>
        </Modal>
        <Modal
          open={this.state.thanksIssueModal}
          onClose={this.closeThankSubmitIssue}
          title="Send Success"
          primaryAction={{
            content: 'OK',
            onAction: this.closeThankSubmitIssue
          }}>
          <Modal.Section>
            <Banner title={bannerTitleThankYouSubmitIssue} status="success"/>
          </Modal.Section>
        </Modal>
      </div>
    )
  }
}

export default SubmitIssue
